/** PURE_IMPORTS_START .._.._Observable,.._.._operator_concatAll PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { concatAll } from '../../operator/concatAll';
Observable.prototype.concatAll = concatAll;
//# sourceMappingURL=concatAll.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/concatAll.js
// module id = 449
// module chunks = 0